import React, { Component } from 'react';
import SideNav from '../../side-nav/side-nav.component';
import "./report-layout.component.css"
class ReportLayout extends Component {
    
    render() {        
        return (
            <>
                <div className='report-layout-main-container'>
                   <SideNav urlType={this.props.urlType}/>      
                    <div className="main-wrapper">
                        {this.props.children}
                    </div>                   
                </div>

            </>
        )
    }

}

export default ReportLayout;
